export const sleep = (time) => new Promise((resolve) => setTimeout(resolve, time))

export const humanDuration = (time) => {
  const sign = time < 0 ? '-' : ''
  const absTime = Math.abs(time)
  const minutes = Math.floor(absTime / 60).toString().padStart(2, '0')
  const seconds = Math.floor(absTime % 60).toString().padStart(2, '0')
  return `${sign}${minutes}:${seconds}`
}

export const playDummyAudio = () => {
  if (!window.audio) {
    window.audio = new Audio(dummyAudioBase64)
    window.audio.play().catch(() => {})
  }
}

// $ sox -n -r 22050 -b 16 -c 1 -e signed-integer dummy.wav trim 0.0 0.1
// $ ffmpeg -i "dummy.wav" -vn -ac 1 -ar 22050 -ab 8k -acodec libmp3lame -f mp3 "dummy.mp3"
// $ base64 -i dummy.mp3
const dummyAudioBase64 = 'data:audio/mp3;base64,SUQzBAAAAAAAIlRTU0UAAAAOAAADTGF2ZjYwLjMuMTAwAAAAAAAAAAAAAAD/83DAAAAAAAAAAAAASW5mbwAAAA8AAAAGAAABUwCdnZ2dnZ2dnZ2dnZ2dnZ2dsbGxsbGxsbGxsbGxsbGxsbHFxcXFxcXFxcXFxcXFxcXF2NjY2NjY2NjY2NjY2NjY2Njs7Ozs7Ozs7Ozs7Ozs7Ozs7P////////////////////8AAAAATGF2YzYwLjMuAAAAAAAAAAAAAAAAJAKjAAAAAAAAAVOtqmREAAAAAAAAAAAAAAAAAP/zEMQAAiAGCAAAAADb/0ej6C78hrVl/+5X//MSxAQC8AYgAAhGAP9aJdS/1uWpbU1VeK/9//MQxAYCyAYgAAgAAJ+q1L/MKvufX9nr16P/8xDEBwKoAiQAAAAA/HcURdhGp//Yizq0f//zEMQJAmgCIAAAAABa9rv/T+SIrATueI1M//MQxAwCqAH4AAAAAEFNRTMuMTAwVVVVVVU='
